import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import TaskList from 'components/tasks/task_list';

import { nextTaskPage } from './store/actions/search';
import { toggleTaskState } from './store/actions/tasks';
import { deleteTask, updateTask } from './store/actions/tasks';
import { each, map } from 'lodash';

export class ProjectsView extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.arrayOf(PropTypes.array),
    databaseMembers: PropTypes.array.isRequired,
    hasNextPage: PropTypes.bool,
    selectedId: PropTypes.number,
    tasks: PropTypes.arrayOf(PropTypes.shape({
      associatedModels: PropTypes.arrayOf(PropTypes.shape({
        associatedModelId: PropTypes.number.isRequired,
        associatedModelType: PropTypes.string.isRequired
      })).isRequired
    })).isRequired,
    onDeleteTask: PropTypes.func.isRequired,
    onNextPage: PropTypes.func.isRequired,
    onToggleTaskState: PropTypes.func.isRequired,
    onUpdateTask: PropTypes.func.isRequired
  };

  groupTasks() {
    const groups = {};
    const noProjects = [];
    const { tasks } = this.props;

    const notCompletedTasks = tasks.filter(task => !task.completed);

    each(notCompletedTasks, (task) => {
      const taskProjects = task.associatedModels.filter(model => model.associatedModelType === 'Project');

      if (taskProjects.length > 0) {
        each(taskProjects, (project) => {
          const projectId = project.associatedModelId;
          groups[projectId] = groups[projectId] || { id: projectId, title: project.name, tasks: [] };
          groups[projectId].tasks.push(task);
        });
      } else {
        noProjects.push(task);
      }
    });

    const results = Object.values(groups);
    results.push({
      id: 'no-project',
      title: 'No Project',
      tasks: noProjects
    });
    return results;
  }

  render() {
    const {
      availableDatabases,
      selectedId,
      hasNextPage,
      databaseMembers,
      onDeleteTask,
      onNextPage,
      onToggleTaskState,
      onUpdateTask
    } = this.props;

    const lists = map(this.groupTasks(), (group, i) => {
      const tableClass = classNames({
        'contacts-tasks': group.tasks.length > 0
      });

      return (
        <React.Fragment key={i}>
          <tr>
            <td colSpan="100%">
              <h3 className="py-4 mb-0">{group.title}</h3>
            </td>
          </tr>
          <tbody className={tableClass}>
            <TaskList
              availableDatabases={availableDatabases}
              databaseMembers={databaseMembers}
              key={group.id}
              name={`group-${group.id}`}
              selectedId={selectedId}
              showLoadMoreLink={hasNextPage}
              onDeleteTask={onDeleteTask}
              onLoadMoreTasks={onNextPage}
              onToggleTaskState={onToggleTaskState}
              onUpdateTask={onUpdateTask}
              {...group}
            />
          </tbody>
        </React.Fragment>
      );
    });

    return (
      <React.Fragment>
        <table className="table table-condensed">
          {lists}
        </table>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  availableDatabases: state.static.availableDatabases,
  hasNextPage: state.search.hasNextPage,
  tasks: state.search.tasks
});

const mapDispatchToProps = {
  onDeleteTask: deleteTask,
  onNextPage: nextTaskPage,
  onToggleTaskState: toggleTaskState,
  onUpdateTask: updateTask
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsView);
